import React, { useState, useEffect, useRef } from 'react';
import 'antd/dist/antd.css';
import '@ant-design/compatible/assets/index.css';
import _ from 'lodash'; // Import the entire lodash library
import { Grid, AutoSizer } from 'react-virtualized';
import { Col, Tag } from 'antd';
import { getRelevanceBasedOrderedSearchResult } from '../../Utilities';
import ENVIRONMENT from '../../../../environments';
import FileConstants from '../../../../FileConstants';
import ProductCard from './ProductCard';

const ProductListVirtualized = (props) => {
    const virtualizerContainer = useRef();
    const [filteredValues, setFilteredValues] = useState([]);
    const [columnCount, setColumnCount] = useState(4);
    const [rowCount, setRowCount] = useState(0);
    const maxColWidth = 280;
    const {
        productsAddedToScene,
        setProductsAddedToScene,
        productsData,
        type,
        searchValue,
        colorValue,
        setColorValue,
        productCategoryValue,
        setProductCategoryValue,
        changeProductCategory,
        productStyleCategory,
        setProductStyleCategory,
        productMaterials,
        setProductMaterials,
        productModelType,
        setProductModelType,
        requestPlan,
        setData,
        filtersApplied,
        returnSearchValue,
        selectedRoom,
        isStore,
        requestStatusRoom
    } = props;
    const filtersHeight = `calc(100vh - ${filtersApplied ? '300px' : '220px'
        })`;


    const cellRenderer = ({ columnIndex, key, rowIndex, style }) => {
        const data = filteredValues;
        const itemIndex = rowIndex * columnCount + columnIndex;
        const ele = data[itemIndex] && data[itemIndex];
        if (!ele) {
            return null;
        }
        const id = ele.id;
        const name = ele.name;
        let thumbnail = ele.thumbnail;
        thumbnail = thumbnail.replace(
            ENVIRONMENT.DEFAULT_BASE_URL,
            ENVIRONMENT.getBaseURL(ele.platform),
        );
    

        return (
            <div key={key} style={style}>
                <ProductCard
                    selectedRoom={selectedRoom}
                    setProductsAddedToScene={setProductsAddedToScene}
                    productsAddedToScene={productsAddedToScene}
                    item_type={ele.item_type}
                    id={ele.id}
                    name={ele.name}
                    price={ele.price}
                    customer_username={ele.customer_username}
                    company_display_name={ele.company_display_name}
                    company_id={ele.company_id}
                    getRequestPlan={requestPlan}
                    itemType={type}
                    thumbnail={thumbnail}
                    category={ele.category}
                    subscriptionPlan={''}
                    platform={ele.platform}
                    ele={ele}
                    isStore = {isStore}
                    requestStatusRoom = {requestStatusRoom}
                />
            </div>
        );
    };

    useEffect(()=>{
        // no of rows based on the data length
        let data = [];

        // validationns to apply filters and search
        if (searchValue == '' && !filtersApplied) {
            data = [...productsData]; 
        } 
        else if (searchValue != '' || filtersApplied) {
            if(searchValue != '' && !filtersApplied){
                data = getRelevanceBasedOrderedSearchResult(searchValue, productsData)
            } else if (searchValue == '' && filtersApplied) {
                data = productsData.filter(returnSearchValue)
            } else if (searchValue != '' && filtersApplied) {
                let filter_data = productsData.filter(returnSearchValue)
                data = getRelevanceBasedOrderedSearchResult(searchValue, filter_data)
            }
        }

        setData(data);
        setFilteredValues(data);
        setRowCount(Math.ceil(data.length / columnCount));
    }, [searchValue, filtersApplied, productsData]);


    const getFilteredTags = () => {
        let filteredTags = <>
            {filtersApplied && <Col span={24} style={{ marginLeft: 10, marginTop: 20, textAlign: "left" }}>
                <h4 className='manrope f-14 black-55 italic'>Showing results for</h4>
                <div style={{ marginBottom: 20 }}>
                    {
                        productCategoryValue.length > 0 && productCategoryValue.map((category) => {
                            return <Tag onClose={() => closeTags(category, 'product_category')}
                                closable visible={true}
                                className='manrope f-12 black-55 tag-filter'>Category: <span className='manrope f-12 grey-77'>{category}</span></Tag>
                        })}

                    {productStyleCategory.length > 0 && productStyleCategory.map((category) => {
                        return <Tag onClose={() => closeTags(category, 'product_style_category')} closable visible={true} className='manrope f-12 black-55 tag-filter'>Style Category: <span className='manrope f-12 grey-77'>{category}</span></Tag>
                    })}

                    {colorValue.length > 0 && colorValue.map((category) => {
                        return <Tag onClose={() => closeTags(category, 'product_color')} closable visible={true} className='manrope f-12 black-55 tag-filter'>Color: <span className='manrope f-12 grey-77'>{category}</span></Tag>
                    })}

                    {
                        productMaterials.length > 0 && productMaterials.map((category) => {
                            return <Tag onClose={() => closeTags(category, 'product_material')} closable visible={true} className='manrope f-12 black-55 tag-filter'>Material: <span className='manrope f-12 grey-77'>{category}</span></Tag>
                        })}

                    {
                        productModelType.length > 0 && productModelType.map((category) => {
                            return <Tag onClose={() => closeTags(category, 'product_model_type')} closable visible={true} className='manrope f-12 black-55 tag-filter'>Product Type: <span className='manrope f-12 grey-77'>{FileConstants.PRODUCT_MODEL_TYPE[category]}</span></Tag>
                        })}

                </div>
            </Col>}
        </>

        return filteredTags;
    }

    const closeTags = (entity, type) => {
        //remove the tag when this is clicked from showing result section
        if (type == 'product_category') {
            let arr = productCategoryValue.filter(category => { return entity != category });
            changeProductCategory(arr)
        } else if (type == 'product_style_category') {
            let arr = productStyleCategory.filter(style_category => { return entity != style_category });
            setProductStyleCategory(arr);
        } else if (type == 'product_color') {
            let arr = colorValue.filter(color => { return entity != color });
            setColorValue(arr);
        } else if (type == 'product_material') {
            let arr = productMaterials.filter(material => { return entity != material });
            setProductMaterials(arr);
        } else if (type == 'product_model_type') {
            let arr = productModelType.filter(model => { return entity != model });
            setProductModelType(arr);
        }
    }



    return (
        <>
            {getFilteredTags()}
            <div
                ref={virtualizerContainer}
                style={{ width: '100%', height: filtersHeight }}
            >
                {productsData.length == 0 && (
                    <div
                        className="empty-section"
                        style={{
                            marginTop: '10%',
                            position: 'relative',
                            textAlign: '-webkit-center',
                        }}
                    >
                        <img
                            id="empty-section-image"
                            style={{ width: '10%' }}
                            src="../../../../img/Collections.svg"
                        />
                        <p className="empty-section-text manrope f-14 black-55">
                            Nothing to show
                        </p>
                    </div>
                )}
                <AutoSizer>
                    {({ height, width }) => {
                        const colCount =
                            (Math.floor(width / maxColWidth) > 4 ?
                                4 :
                                Math.floor(width / maxColWidth)) || 1;
                        setColumnCount(colCount);
                        setRowCount(Math.ceil(filteredValues.length / colCount));
                        const colWidth = width / colCount;
                        return (
                            <Grid
                                className='product-tab-content-scrollable'
                                cellRenderer={cellRenderer}
                                columnCount={colCount}
                                columnWidth={colWidth}
                                height={height}
                                rowCount={rowCount}
                                estimatedRowSize={100}
                                rowHeight={390}
                                width={width + 10}
                            />
                        );
                    }}
                </AutoSizer>
            </div>
        </>
    );
};

export default ProductListVirtualized;
